import dayjs from 'dayjs'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { callApiWithLead } from 'api/utils'
import { getLeadPath } from 'api/utils/paths'

import { FrisoFormFieldProps } from '.'

export const verifyPhoneExistApi = async (phone: string) =>
  await callApiWithLead(
    getLeadPath(PATHS.LEADGEN.POST_LEAD_FRISO_VERIFY_PHONE_EXIST),
    'POST',
    {
      data: {
        phone,
      },
    },
  )

export const verifyEmailExistByCampaignCodeApi = async (
  email: string,
  campaignCode: string,
) =>
  await callApiWithLead(
    getLeadPath(PATHS.LEADGEN.POST_LEAD_VERIFY_EXIST_EMAIL),
    'POST',
    {
      data: {
        email,
        campaign_code: campaignCode,
      },
    },
  )

export const verifyPhoneExistByCampaignCodeApi = async (
  phone: string,
  campaignCode: string,
) =>
  await callApiNew(
    PATHS.LEADGEN.POST_LEAD_VERIFY_EXIST_PHONE,
    {
      method: 'POST',
      data: {
        phone,
        campaign_code: campaignCode,
      },
    },
    'lead',
  )

export const saveLeadApi = async (values?: FrisoFormFieldProps) => {
  const { first_name, last_name, address, dob, email, phone } = values || {}
  return await callApiWithLead(
    getLeadPath(PATHS.LEADGEN.POST_LEAD_LEAD, {
      campaignCode:
        process.env.NEXT_PUBLIC_FRISO_COMPAIGN_CODE || 'wufl4mh2vunsklq',
    }),
    'POST',
    {
      data: {
        url: window.location.href,
        title_article: document.title,
        referrer: 'hlbs_pooptracker',
        meta: [
          {
            key: 'first_name',
            value: first_name || '',
            control: 'text',
          },
          {
            key: 'last_name',
            value: last_name || '',
            control: 'text',
          },
          {
            key: 'due_date_dob',
            value: dob ? dayjs(dob).format('YYYY-MM-DD') : '',
            control: 'due_date_dob',
          },
          {
            key: 'province',
            value: address?.selectedProvince || '',
            control: 'province',
          },
          {
            key: 'email',
            value: email || '',
            control: 'email',
          },
          {
            key: 'phone',
            value: phone || '',
            control: 'tel',
          },
          {
            key: 'address',
            value: address
              ? [
                  address?.selectedProvince || '',
                  address?.selectedDistrict || '',
                  address?.selectedWard || '',
                  address?.extraInfo || '',
                ].join('; ')
              : '',
            control: 'text',
          },
        ],
      },
    },
  )
}

export const onResendCode = async (phoneNumber: string) => {
  await callApiWithLead(getLeadPath(PATHS.LEADGEN.POST_LEAD_SEND_OTP), 'POST', {
    data: {
      phone_number: phoneNumber,
    },
  })
}
